import React from 'react';
import { Timeline, TimelineRegistry, TimelineResponseData } from 'framework/ui/timeline';
import PersonTimelinePageLayout, { AddTimelineItemInputProps } from './PersonTimelinePageLayout';
import PersonTimelineLayout, { FormConfigMap } from './PersonTimelineLayout';
import { Filter } from 'framework/list';
import { ResourceId } from 'framework/crud';

export type { BasePersonTimelineRecordLayoutProps } from './PersonTimelineRecord/BasePersonTimelineRecordLayout';
export { default as PersonTimelineRecordActions } from './PersonTimelineRecord/PersonTimelineRecordActions';

interface PersonTimelineProps {
  entityId: string;
  registries: TimelineRegistry[];
  breadcrumbs?: React.ReactNode;
  entityHeader?: React.ReactNode;
  menu?: React.ReactNode;
  getTimelineItems: (entityId: string, request: any) => Promise<TimelineResponseData>;
  createTimelineItem: (entityId: string, itemType: string, request: any) => Promise<any>;
  getTimelinePageById: (entityId: string, entryId: string) => Promise<TimelineResponseData>;
  timelineEntryIdSource?: string;
  defaultFilter?: Filter;
  filter?: React.ReactNode;
  additionalButtons?: React.ReactNode[];
  noEntriesMessage?: string;
  messageContext: string;
  formConfig?: FormConfigMap;
  timelineHeader?: React.ReactNode;
  AddTimelineItemInput?: React.ComponentType<AddTimelineItemInputProps>;
  hasAddForm?: boolean;
  pinTimelineAction?: (entityId: ResourceId, timelineId: ResourceId, pinStatus: boolean) => Promise<any>;
}

const PersonTimeline: React.FC<PersonTimelineProps> = ({
  entityId,
  registries,
  breadcrumbs,
  entityHeader,
  menu,
  timelineHeader = null,
  getTimelineItems,
  createTimelineItem,
  getTimelinePageById,
  timelineEntryIdSource = 'timelineEntryId',
  defaultFilter,
  filter,
  additionalButtons,
  noEntriesMessage = 'No entries in this timeline yet.',
  messageContext,
  formConfig,
  AddTimelineItemInput,
  hasAddForm = true,
  pinTimelineAction,
}) => {
  return (
    <Timeline
      registries={registries}
      getDataMethod={request => getTimelineItems(entityId, request)}
      createTimelineItemMethod={(itemType, request) => createTimelineItem(entityId, itemType, request)}
      getPageByEntryIdMethod={id => getTimelinePageById(entityId, String(id))}
      timelineEntryIdSource={timelineEntryIdSource}
      defaultFilter={defaultFilter}
      pinTimelineAction={pinTimelineAction}
    >
      <PersonTimelinePageLayout
        filter={filter}
        timelineHeader={timelineHeader}
        additionalButtons={additionalButtons}
        messageContext={messageContext}
        AddTimelineItemInput={AddTimelineItemInput}
        hasAddForm={hasAddForm}
        breadcrumbs={breadcrumbs}
        entityHeader={entityHeader}
        menu={menu}
      >
        <PersonTimelineLayout
          noEntriesMessage={noEntriesMessage}
          messageContext={messageContext}
          formConfig={formConfig}
        />
      </PersonTimelinePageLayout>
    </Timeline>
  );
};

export default PersonTimeline;
